export default __webpack_public_path__ + "static/media/a6.86a3ba34.png";